import { useEffect } from 'react';

// This hook adds or removes a class from the body element based on a condition
interface IUseBodyClassProps {
  className: string;
  condition: boolean;
}
const useBodyClass = ({ className, condition }: IUseBodyClassProps) => {
  useEffect(() => {
    const body = document.body;

    // Add or remove the class based on the condition
    if (condition) {
      body.classList.add(className);
    } else {
      body.classList.remove(className);
    }

    // Cleanup function to remove the class
    return () => {
      body.classList.remove(className);
    };
  }, [className, condition]);
};

export default useBodyClass;
